export default __webpack_public_path__ + "static/media/Rupal_Vora.0d9b0e57.jpg";